


















// @ts-ignore
import v8n from 'v8n';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { bookingModule, snackModule } from '@/store';
import BookingExtras from '@/components/booking/BookingExtras.vue';
import { Extra, ExtraVariation } from '@/api';
import { ApiError } from '@/api';

@Component({
  components: { BookingExtras },
})
export default class extends Vue {
  loading: boolean = false;
  valid: boolean = false;

  extras: Extra[] = [];
  extraVariations: ExtraVariation[] = [];

  requiredString = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'This field is required',
  ];

  get booking() {
    if (!bookingModule.booking) {
      return;
    }
    return bookingModule.booking;
  }

  bookingBack() {
    this.$router.back();
  }

  step5() {
    if (!this.booking) {
      return;
    }
    bookingModule.setCompletedStep(5);

    let extrasPrice = null;
    if (this.booking.extras) {
      extrasPrice = this.booking.extras.reduce((a, b) => {
        let price = b.basePrice;
        const variant = this.extraVariations.find(
          (variation: ExtraVariation) => variation.extra.id === b.id,
        );
        if (variant && variant.price) {
          price = variant.price;
        }
        return a + (Number(price) || 0);
      }, 0);
    }

    bookingModule.setExtrasPrice(extrasPrice);

    this.$router.push({
      name: 'booking-step-6',
    });
  }

  async mounted() {
    bookingModule.setCurrentStep(5);
    bookingModule.checkStatus();
    if (!this.booking) return;

    try {
      const vehicleType = this.booking.customer
        ? this.booking.vehicle.vehicleType
        : this.booking.vehicleType;

      this.extraVariations = (
        await ExtraVariation.where({ vehicleType: vehicleType.id }).all()
      ).data;

      const { startDatetime, endDatetime } = this.booking;
      this.extras = (
        await Extra.where({ checkAvailability: [startDatetime, endDatetime] }).all()
      ).data;

    } catch (err) {
      err.response.errors.forEach((e: ApiError) =>
        snackModule.showSnackbar(e.detail),
      );
    }
  }
}
